import { render, staticRenderFns } from "./user-modal.vue?vue&type=template&id=52101e7f&scoped=true&"
import script from "./user-modal.vue?vue&type=script&lang=js&"
export * from "./user-modal.vue?vue&type=script&lang=js&"
import style0 from "./user-modal.vue?vue&type=style&index=0&id=52101e7f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52101e7f",
  null
  
)

export default component.exports